export const CONTENT_VERSION = 'lgpd-trilha-2026.08';
export const PASS_CUT = 7;
export const ITEM_COUNT = 9;
export const SLIDE_COUNT = 30;
export const ANPD_DISCLAIMER =
  'Certificado interno Altec. Não é credenciamento da ANPD.';
export const ENCARREGADO = '[nome a preencher na semana 0]';
export const STORAGE_KEY = 'altec-academia-lgpd-v1';
export const COURSE_IDS = Object.freeze([
  'escudo-estelar',
  'cofre-quantico',
  'rede-nebulosa',
]);

/** 1-based slide number → beat in the canon 30-slide clock. */
export const CLOCK = Object.freeze([
  null,
  'hook',
  'hook',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'quiz',
  'quiz',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'quiz',
  'quiz',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'lesson',
  'quiz',
  'quiz',
  'quiz',
  'recap',
  'recap',
  'certificate',
]);

export const TECA_POSES = Object.freeze([
  'teca-acena',
  'teca-explica',
  'teca-pensa',
  'teca-sim',
  'teca-nao',
  'teca-alerta',
  'teca-cadeado',
  'teca-incidente',
  'teca-festeja',
  'teca-nebula',
  'teca-lousa',
  'teca-abraco',
  'teca-lupa',
  'teca-abre',
  'teca-livro',
  'teca-agradece',
]);
